import { useCallback, useEffect, useRef, useState } from 'react';

import { sentryLogger } from '@/adapters/logger/sentryLogger';

export interface UseRefreshHandlerResult {
  onRefresh: () => Promise<void>;
  refreshing: boolean;
}

export const useRefreshHandler = (handler: () => Promise<unknown>): UseRefreshHandlerResult => {
  const [refreshing, setRefreshing] = useState(false);
  const handlerRef = useRef(handler);

  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  const onRefresh = useCallback(async () => {
    setRefreshing(true);
    try {
      await handlerRef.current();
    } catch (error) {
      sentryLogger.captureException(error);
    } finally {
      setRefreshing(false);
    }
  }, []);

  return { onRefresh, refreshing };
};
